import API from "..";
export default class PiscesTest {
    /**
     * The Container dimension table for M3
     * @param TODO
     */
    constructor({
      methodName,
      testFacilityAbv,
      conditionOfferingName,
      methodDescription,
      sampleName,
      submittedDate,
      receivedDate,
      reportedDate,
      status,
      requesterEmail,
      submitterEmail,
      testEstimate,
      priority,
      testGroup,
      billingInfo,
      inProgressDate,
      analystEmail,
      testSequenceNumber,
      testFacilityName,
      age,
      testComment,
      externalLaboratoryName
    }) {
      this.methodName = methodName;
      this.testFacilityAbv = testFacilityAbv;
      this.conditionOfferingName = conditionOfferingName;
      this.methodDescription = methodDescription;
      this.sampleName = sampleName;
      this.submittedDate = submittedDate;
      this.receivedDate = receivedDate;
      this.reportedDate = reportedDate;
      this.status = status;
      this.requesterEmail = requesterEmail;
      this.submitterEmail = submitterEmail;
      this.testEstimate = testEstimate;
      this.priority = priority;
      this.testGroup = testGroup;
      this.billingInfo = billingInfo;
      this.inProgressDate = inProgressDate;
      this.analystEmail = analystEmail;
      this.testSequenceNumber = testSequenceNumber;
      this.testFacilityName = testFacilityName;
      this.age = age;
      this.testComment = testComment;
      this.testFacilityFullName = `${testFacilityAbv} - ${testFacilityName}`;
      this.externalLaboratoryName = externalLaboratoryName;
    }


    static async get(startDate, endDate, testFacilities, methodNames, page, resultsPerPage) {
      const queryFacility = testFacilities.join('&testFacilities=');
      const queryMethod = methodNames.join('&methodNames=');
      const api = await API();
      const { data } = await api.get(`/piscesreporting/test?startDate=${startDate}&endDate=${endDate}&page=${page}&resultsPerPage=${resultsPerPage}${queryFacility ? '&testFacilities=' + queryFacility : ''}${queryMethod ? '&methodNames=' + queryMethod : ''}`);

      return data.result.map((d) => new PiscesTest(d));
    }

}